module.exports = __webpack_public_path__ + "static/img/people.c51823dd.png";